export const CREATE_PRODUCTIONLINE45460 = "CREATE_PRODUCTIONLINE45460";
export const UPDATE_PRODUCTIONLINE45460 = "UPDATE_PRODUCTIONLINE45460";
export const DELETE_PRODUCTIONLINE45460 = "DELETE_PRODUCTIONLINE45460";
export const FETCH_PRODUCTIONLINE45460 = "FETCH_PRODUCTIONLINE45460";
export const LISTEN_TO_SELECTED_PRODUCTIONLINE45460 =
  "LISTEN_TO_SELECTED_PRODUCTIONLINE45460";
